import React from 'react';
import { Modal, Button } from 'semantic-ui-react';

interface DeleteConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  itemName?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  open,
  onCancel,
  onConfirm,
  itemName,
}) => (
    <Modal open={open} onClose={onCancel} size="small">
      <Modal.Header>Confirm Delete</Modal.Header>
      <Modal.Content>
        <p>
          Are you sure you want to delete{' '}
          <strong>{itemName || 'this item'}</strong>?
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button negative onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Actions>
    </Modal>
  );

export default DeleteConfirmationModal;
